<template>
  <div class="calico-pagination">
    <div class="pages">
      <pagination-tab :page="prev">
        <i class="bi bi-chevron-left" />
      </pagination-tab>
      <pagination-tab :page="1">
        <label class="label--medium">{{ 1 }}</label>
      </pagination-tab>
      <pagination-tab
        v-if="view > 0"
        @click.prevent="updateView(-1)"
      >
        <label class="label--medium">...</label>
      </pagination-tab>
      <pagination-tab 
        v-for="page in pagesRange[view]" 
        :key="page" 
        :page="page"
      >
        <label class="label--medium">{{ page }}</label>
      </pagination-tab>
      <pagination-tab
        v-if="view < (pagesRange.length - 1)"
        @click.prevent="updateView(1)"
      >
        <label class="label--medium">...</label>
      </pagination-tab>
      <pagination-tab 
        v-if="pages > 1" 
        :page="pages"
      >
        <label class="label--medium">{{ pages }}</label>
      </pagination-tab>
      <pagination-tab :page="next">
        <i class="bi bi-chevron-right" />
      </pagination-tab>
    </div>
    <span
      v-if="label && showLabel()"
      class="body--xsmall"
    >
      {{ label }}
    </span>
  </div>
</template>

<script>
import PaginationTab from '@/components/calico/pagination-tab/index.vue';

export default {
  name: "CalicoPagination",
  components: {
    PaginationTab
  },
  props: {
    pages: { type: Number, default: 1 },
    label: { type: String, default: '' },
  },
  data() {
    return {
      view: 0,
    }
  },
  computed: {
    next() {
      return Number(this.$route.query.page) + 1 <= this.pages ? Number(this.$route.query.page) + 1 : 0
    },
    prev() {
      return Number(this.$route.query.page) - 1
    },
    pagesRange() {
      return Array.from({ length: this.pages }, (_, i) => i + 1).slice(1, this.pages - 1).chunk(5)
    }
  },
  watch: {
    '$route.query.page': {
      handler() {
        this.updateView();
      },
      immediate: true
    }
  },
  methods: {
    updateView(view) {
      if (view)
        this.view = this.view + view
      else
        this.view = this.$route.query.page < this.pages ? Math.max(this.pagesRange.findIndex(section => section.includes(Number(this.$route.query.page))), 0) : this.pagesRange.length - 1
    },
    showLabel() {
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
.calico-pagination {
  @include stack-space($space-xsmall);
  align-items: center;

  .pages {
    @include inline-space($space-xsmall);
    align-items: center;
  }

  .bi {
    font-size: $icon-xsmall;
  }

  span {
    color: $color-neutral;
  }
}
</style>